/**
 * LandingPage Component
 * Main landing page for HR4India showcasing HR consulting services and OKRHub product
 */

import React, { useEffect } from 'react';
import { SEO } from '../../components/landing/SEO';
import {
  LandingNav,
  Hero,
  Contact,
  Footer
} from '../../components/landing';
import { ProblemSection } from '../../components/landing/ProblemSection';
import { PhilosophySection } from '../../components/landing/PhilosophySection';
import { ThreePillarsSection } from '../../components/landing/ThreePillarsSection';
import { DifferentiationSection } from '../../components/landing/DifferentiationSection';
import { ClientScenariosSection } from '../../components/landing/ClientScenariosSection';
import { ResourcesSection } from '../../components/landing/ResourcesSection';
import { OKRHubProductSection } from '../../components/landing/OKRHubProductSection';

export const LandingPage: React.FC = () => {
  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags */}
      <SEO />

      {/* Navigation */}
      <LandingNav />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <Hero />

        {/* Problem/Trust Section */}
        <ProblemSection />

        {/* Philosophy Section */}
        <PhilosophySection />

        {/* Three Pillars (Services) Section */}
        <ThreePillarsSection />

        {/* OKRHub Product Section */}
        <OKRHubProductSection />

        {/* Differentiation Section */}
        <DifferentiationSection />

        {/* Client Scenarios Section */}
        <ClientScenariosSection />

        {/* Resources Section */}
        <ResourcesSection />

        {/* Contact & CTA */}
        <Contact />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};
